import { useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { FormInput } from '../../wrappers/formInput';
import Button from '../../components/button';
  import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Styles from "./styles.module.scss";
import classnames from "classnames";
import { DropDownInput } from '../../wrappers/selectInput';
import * as CONSTANTS from "../../utils/CONSTANTS";

export type TaxformFields = {
    type: string;
    reason: string;
    percentage: number;
};

interface Props {
    ClickHandler: (event: any) => void
    percentage: any
  }

  const validationSchema = Yup.object({
    reason: Yup.string()
      .required("Field is required"),
    percentage: Yup.string()
      .required("Field is required")
  });

export const GstForm: React.FC <Props> = ({ClickHandler, percentage}) => {

  const formOptions = { resolver: yupResolver(validationSchema) };

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm<TaxformFields>(formOptions);

  useEffect(() => {
    if(percentage){
      setValue('percentage', percentage)
      onSubmit()
    }
  }, [])
    

  const onChnage = (e: any) => {
    setValue('percentage', parseInt(e.target.value))
    onSubmit()
  }
  
  const onSubmit = () => {
    
    let values = getValues()
    ClickHandler(values)
    
  };

  return (
    <div className={Styles.deductions}>
    <form >
      <div className={classnames(Styles.reasonFiled, "form-group")}>
      <DropDownInput<TaxformFields>
                    name="type"
                    data={CONSTANTS.deductionType}
                    register={register}
                    errors={errors}
                    control={control}
                    label="Type"
                    // textField='name'
                    // dataItemKey='id'
                    defaultValue={'Arrears'}
                    disabled={true}
                />
      </div>
      <div className={classnames(Styles.reasonFiled, "form-group")}>
      <FormInput<TaxformFields>
        id="reason"
        type="reason"
        name="reason"
        placeholder="percentage"
        label="Reason"
        register={register}
        errors={errors}
        onBlur={onSubmit}
        defaultValue={'GST'}
        disabled={true}
      />
    </div>
      <div className={classnames(Styles.amountFiled, "form-group")}>
      <FormInput<TaxformFields>
        id="percentage"
        type="number"
        name="percentage"
        placeholder="percentage"
        label="Percentage"
        register={register}
        errors={errors}
        onchange={(e: any) => onChnage(e)}
        defaultValue={percentage}
      />
      </div>
    </form>
    </div>
  );
};

